import { render, staticRenderFns } from "./ProposalPremiumInfo.vue?vue&type=template&id=14b94720"
import script from "./ProposalPremiumInfo.vue?vue&type=script&lang=js"
export * from "./ProposalPremiumInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports